import { AfterContentChecked, AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DomSanitizer, SafeHtml, Title } from '@angular/platform-browser';
import { BaseComponent, DrawerService } from '@portals/core';
import { MatDialog } from '@angular/material/dialog';

import { Observable } from 'rxjs';
import { filter, map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthState } from '@portals/store';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { getChildRoute } from '@portals/utils';
import { Location } from '@angular/common';

import { JottoOnboardComponent } from '@portals/ui';
import { environment } from '@portals/environments';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface MenuItem {
	text: string;
	icon?: IconProp;
	svg?: string;
	routerLink?: string | string[];
	function?: string;
	anchorId?: string;
	customClass?: string;
}

@Component({
	selector: 'portals-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent extends BaseComponent implements OnInit, AfterViewInit {
	@Input() menu: MenuItem[] = [];
	@Input() subMenu: MenuItem[] = [];
	@Input() appName: string = '';
	@ViewChild('tutorialWelcomeDialog', { static: true })
	tutorialWelcomeDialog!: TemplateRef<any>;
	@ViewChild('rightDrawer', { static: true })
	private rightDrawer!: MatSidenav;
	ngClassObject: any = {};
	enableBackButton = false;
	tutorial = environment.tutorial;
	app = environment.app;
	multiProject = environment.multiProject;
	dashboardImage = 'assets/images/dashboard-default.png';
	projectName = '';
	userEmail = '';

	isHandset$: Observable<boolean> = this.breakpointObserver.observe('(max-width: 768px)').pipe(
		map((result) => result.matches),
		shareReplay()
	);

	isTablet$: Observable<boolean> = this.breakpointObserver.observe('(min-width: 768px) and (max-width: 1024px)').pipe(
		map((result) => result.matches),
		shareReplay()
	);

	constructor(public titleService: Title, public drawer: DrawerService, private breakpointObserver: BreakpointObserver, public user: AuthState, private activatedRoute: ActivatedRoute, private router: Router, public dialog: MatDialog, private location: Location, private sanitizer: DomSanitizer) {
		super();

		this.dashboardImage = this.user.data?.project?.image ? this.user.data?.project?.image?.url : 'assets/images/dashboard-default.png';
		this.projectName = this.user.data?.project?.name || '';
		this.userEmail = this.user.data?.email || '';

		// console.log(this)
	}

	ngOnInit(): void {
		this.drawer.connectDrawer(this.rightDrawer);
		this.subscribe(
			this.router.events.pipe(
				filter((event) => event instanceof NavigationEnd),
				switchMap(() => {
					return getChildRoute(this.activatedRoute).data;
				}),
				tap((data) => {
					this.enableBackButton = data['enableBackButton'];
				})
			)
		);
		this.menu.forEach((item) => {
			// console.log(`router item: ${item.text}`);
		});
		this.subMenu.forEach((item) => {
			// console.log(`router item: ${item.text}`);
		});
	}

	ngAfterViewInit() {
		this.subscribe(
			getChildRoute(this.activatedRoute).data.pipe(
				tap((data) => {
					this.titleService.setTitle(data['title']);
				})
			)
		);
	}

	back() {
		this.location.back();
	}

	public logoutUser() {
		this.user.logout();
	}

	navigateTocardcomp() {
		this.router.navigateByUrl('/camVideo');
	}

	startTutorial() {
		this.dialog.open(JottoOnboardComponent, {
			disableClose: true,
			panelClass: 'welcome-tutorial-dialog',
		});
	}

	sanitizeSVG(svgData: string): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(svgData);
	}

	executeFunction(methodName: string) {
		if (typeof this[methodName] === 'function') {
			this[methodName](); // Call the method dynamically
		} else {
			console.error(`Method '${methodName}' does not exist or is not a function.`);
		}
	}

	protected readonly environment = environment;
}
